import React from 'react';
import './Modal.css';

const Modal = ({ message, setModal }) => {
	return (
		<div className='modal-overlay'>
			<div className='modal'>
				<p>{message}</p>
				<button onClick={() => setModal(false)}>OK</button>
			</div>
		</div>
	);
};

export default Modal;
